module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSIxOSIgdmlld0JveD0iMCAwIDEzIDE5Ij4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0YzMzUzNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPg0KICAgICAgICA8cGF0aCBkPSJNNi43NTUgMS4yNThoMy44MzNjLjU1MyAwIDEgLjQ2MSAxIDEuMDNWMTQuNjVjMCAuNTctLjQ0NyAxLjAzLTEgMS4wM2gtOSIvPg0KICAgICAgICA8cGF0aCBkPSJNMy4xMDMgMTMuODE2bC0xLjg1MyAxLjkxIDEuODUzIDEuOTEiLz4NCiAgICA8L2c+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/submit.svg
// module id = 8tP1
// module chunks = 1